import React, { Component } from 'react';
import { connect } from 'dva';
import { Tabs } from 'antd';
import TableList from './components/Table';

const { TabPane } = Tabs;

function callback(key) {
  console.log(key);
}

@connect(({ contactsList }) => ({
  ...contactsList,
}))
class DeptInformationTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  tabsChange = key => {
    const { dispatch, currentselectTreeNode } = this.props;
    dispatch({
      type: 'contactsList/save',
      payload: {
        activeKey: key,
      },
    });
    if (key === 'dept') {
      dispatch({
        type: 'contactsList/fetchDeptList',
        params: {
          deptId: currentselectTreeNode.deptId,
          pageIndex: 0,
          pageSize: 20,
        },
      });
    }
    if (key === 'role') {
      dispatch({
        type: 'contactsList/fetchRoleList',
        params: {
          deptId: currentselectTreeNode.deptId,
          entitySign: currentselectTreeNode.entitySign,
          pageIndex: 0,
          pageSize: 20,
        },
      });
    }
    if (key === 'user') {
      dispatch({
        type: 'contactsList/fetchDeptUserList',
        params: {
          deptId: currentselectTreeNode.deptId,
          pageIndex: 0,
          pageSize: 20,
        },
      });
    }
  };

  render() {
    const { activeKey, deptList, columns, roleList, deptUserList } = this.props;
    return (
      <Tabs onChange={this.tabsChange} type="card" activeKey={activeKey}>
        <TabPane tab="下级部门" key="dept">
          <TableList dataSource={deptList} columns={columns} tabKey="dept" />
        </TabPane>
        <TabPane tab="部门岗位" key="role">
          <TableList dataSource={roleList} columns={columns} tabKey="role" />
        </TabPane>
        <TabPane tab="部门成员" key="user">
          <TableList dataSource={deptUserList} columns={columns} tabKey="user" />
        </TabPane>
      </Tabs>
    );
  }
}

export default DeptInformationTabs;
